<template>

    <div class="layout__container">

        <div class="layout__width-80 layout__padding-clear">
            <div class="layout__padding-20px">
                <div class="text__align-center text__colour-white layout__margin__bottom-25px">
                    <div class="layout__padding-clear layout__width-60 layout__padding-40px-0 layout__border__bottom-light-teal-1px">
                        <h2 class="text__colour-teal">Billing Details</h2>
                        <div class="layout__padding-20-0 text__size-18 text__colour-grey" v-if="!disabledAddress">
                            If you're an online account
                            holder, you can use the following form to update your Billing Address. <br>If you need to
                            change any other contact details, please contact our helpdesk on 0191 9179331.
                        </div>
                        <div class="layout__padding-20-0 text__size-18 text__colour-grey" v-if="disabledAddress">
                            These are the address details we hold on record for your Billing Address.<br>
                            If you need to change any of these details, please contact our helpdesk on 0191 9179331.
                        </div>
                    </div>
                </div>

                <div class="layout__padding-clear layout__width-40">
                    <div class="layout__padding-20-0">
                        <div class="text__size-18">Account Name: {{this.customerName}}</div>
                        <div class="layout__padding-8-0 text__size-18">Account Email: {{this.contactEmail}}</div>
                    </div>
                    <el-form :model="billingAddress" :rules="rules" ref="billingAddress">
                        <el-form-item prop="addr1">
                            <div class="layout__padding-8-0">Address Line 1<span class="text__colour-red">*</span></div>
                            <el-input
                                    placeholder="Address Line 1"
                                    v-model="billingAddress.addr1"
                                    clearable :disabled="this.disabledAddress"
                            ></el-input>
                        </el-form-item>
                        <el-form-item prop="addr2">
                            <div class="layout__padding-8-0">Address Line 2</div>
                            <el-input
                                    placeholder="Address Line 2"
                                    v-model="billingAddress.addr2"
                                    clearable :disabled="this.disabledAddress"
                            ></el-input>
                        </el-form-item>
                        <el-form-item prop="addr3">
                            <div class="layout__padding-8-0">Address Line 3</div>
                            <el-input
                                    placeholder="Address Line 3"
                                    v-model="billingAddress.addr3"
                                    clearable :disabled="this.disabledAddress"
                            ></el-input>
                        </el-form-item>
                        <el-form-item prop="town">
                            <div class="layout__padding-8-0">Town/City<span class="text__colour-red">*</span></div>
                            <el-input
                                    placeholder="Town/City"
                                    v-model="billingAddress.town"
                                    clearable :disabled="this.disabledAddress"
                            ></el-input>
                        </el-form-item>
                        <el-form-item prop="county">
                            <div class="layout__padding-8-0">County<span class="text__colour-red">*</span></div>
                            <el-input
                                    placeholder="County"
                                    v-model="billingAddress.county"
                                    clearable :disabled="this.disabledAddress"
                            ></el-input>
                        </el-form-item>
                        <el-form-item prop="postcode">
                            <div class="layout__padding-8-0">Postcode<span class="text__colour-red">*</span></div>
                            <el-input
                                    placeholder="Postcode"
                                    v-model="billingAddress.postcode"
                                    clearable :disabled="this.disabledAddress"
                            ></el-input>
                        </el-form-item>
                    </el-form>
                    <div class="text__align-center" v-if="!disabledAddress">
                        <el-button class="button-red button__base layout__margin-20-0 layout__width-200px"
                                   v-on:click="updateBillingAddress('billingAddress')">
                            Update Billing Details
                        </el-button>
                    </div>
                    <div id="addressUpdate"></div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    import Axios from 'axios';
    import EventBus from '../../EventBus.js';
    import {axios} from '@/mixins/Axios.js';
    import {sharedQueries} from '@/mixins/SharedQueries.js';
    import {Loading} from 'element-ui';

    export default {
        name: "ClientDetails",
        mixins: [axios, sharedQueries],
        data() {
            const postcodeValidation = (rule, value, callback) => {

                const regexPostcode = /([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})/;

                if (!regexPostcode.test(value)) {
                    callback(new Error('Incorrect Postcode Format'));
                } else {
                    callback(); // this loops back to the calling method
                }
            };
            return {
                role: '',
                billingAddress: {
                    addr1: '',
                    addr2: '',
                    addr3: '',
                    town: '',
                    county: '',
                    postcode: '',
                },
                contactEmail: '',
                customerName: '',
                authCookie: {},
                disabledAddress: false,
                rules: {
                    userReference: [{
                        required: true, message: 'your job reference is required', trigger: 'blur'
                    }],
                    addr1: [{
                        required: true, message: 'required address line 1', trigger: 'blur'
                    }],
                    town: [{
                        required: true, message: 'required town', trigger: 'blur'
                    }],
                    county: [{
                        required: true, message: 'required county', trigger: 'blur'
                    }],
                    postcode: [
                        {
                            required: true, message: 'required postcode', trigger: 'blur'
                        },
                        {
                            validator: postcodeValidation
                        }
                    ],
                }
            }
        },
        // computed: {
        //     userContext() {
        //         return this.returnAllCookies()
        //     }
        // },
        created() {

            this.getBranchBillingAndDeliveryDetails()

            console.log('inside the created method in accounts page')

            if (typeof this.returnCookie("_token") === 'undefined') {
                let parameters = window.location.search.split('=')

                console.log(parameters[1])

                if (parameters[1]) {
                    const getCurrentLoginContext = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Session/GetCurrentLoginContext`

                    Axios.get(getCurrentLoginContext,
                        this.returnHeaderUsingParameter(parameters[1]))

                        .then(response => {
                            this.persistUserSessionUsingParameter(parameters[1], response)

                            console.log('after insert')
                            console.log(this.returnCookie)

                            // EventBus.$emit('update', 'User logged')
                        });

                }
            } else {

                const address = JSON.parse(this.returnCookie("_customer"))
                this.billingAddress.addr1 = address.address1
                this.billingAddress.addr2 = address.address2
                this.billingAddress.addr3 = address.address3
                this.billingAddress.town = address.town
                this.billingAddress.county = address.county
                this.billingAddress.postcode = address.postcode

                this.customerName = address.customerName
                this.contactEmail = address.accountsEmail


                if (JSON.parse(this.returnCookie("_role")).includes('AccountCustomer')) {
                    // todo an account customer
                    this.disabledAddress = true
                }
            }
        },
        methods: {
            updateBillingAddress(billingAddress) {

                this.$refs[billingAddress].validate((valid) => {
                    if (valid) {

                        let loadingInstance = Loading.service({
                            fullscreen: true
                        });

                        const customer = JSON.parse(this.returnCookie("_customer"))

                        const updateAddress = {
                            "id": customer.id,
                            "ref": customer.ref,
                            "address1": this.billingAddress.addr1,
                            "address2": this.billingAddress.addr2,
                            "address3": this.billingAddress.addr3,
                            "town": this.billingAddress.town,
                            "county": this.billingAddress.county,
                            "postcode": this.billingAddress.postcode
                        }

                        console.log('making call')
                        console.log(updateAddress)

                        const updateAddressUrl = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Customer/Update`
                        Axios.put(updateAddressUrl, updateAddress, this.returnHeaderUsingToken())
                            .then(response => {
                                console.log('done')
                                console.log(response.data.result)
                                //todo maybe this needs to be extracted with an update cookie method
                                // document.cookie = '_customer=' + JSON.stringify(response.data.result)
                                window.sessionStorage.setItem("_customer", JSON.stringify(response.data.result))
                                document.getElementById("addressUpdate").innerText = "Successfully updated billing information"
                                document.getElementById("addressUpdate").classList.add('component__message-base', 'component__message-success')

                                this.$nextTick(() => { // Loading should be closed asynchronously
                                    loadingInstance.close();
                                });
                            })
                            .catch(error => {
                                console.log(error)
                                document.getElementById("addressUpdate").innerText = "There was a problem updating the billing information - please try again"
                                document.getElementById("addressUpdate").classList.add('component__message-base', 'component__message-fail')

                                this.$nextTick(() => { // Loading should be closed asynchronously
                                    loadingInstance.close();
                                });
                            })

                    } else {
                        return false;
                    }
                })


                // const customer = JSON.parse(this.returnCookie("_customer"))
                //
                // console.log(JSON.parse(this.returnCookie("_customer")))
                // console.log(customer)
                //
                // const updateAddress = {
                //     "id": customer.id,
                //     "address1": this.billingAddress.addr1,
                //     "address2": this.billingAddress.addr2,
                //     "address3": this.billingAddress.addr3,
                //     "town": this.billingAddress.town,
                //     "county": this.billingAddress.county,
                //     "postcode": this.billingAddress.postcode
                // }

                // const updateAddressUrl = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Customer/Update`
                // Axios.put(updateAddressUrl, updateAddress, this.returnHeaderUsingToken())
                //     .then(response => {
                //todo maybe this needs to be extracted with an update cookie method
                // document.cookie = '_customer=' + JSON.stringify(response.data.result)
                // })
            }

        }
    };
</script>